import { MapPin } from "lucide-react";
import { LiveMap } from "@/components/LiveMap";

// Live Leaflet map (OpenStreetMap, no API key). Victim is fixed; responders
// interpolate toward the victim based on their current status.
const PROGRESS = { notified: 1, standby: 0.9, accepted: 0.6, en_route: 0.3, arrived: 0, declined: 1 };

export const EmergencyMap = ({ victim, responders = [], accuracy, label }) => {
  if (!victim || victim.lat == null || victim.lng == null) {
    return (
      <div className="w-full h-52 rounded-3xl border border-[#111827]/10 bg-[#e8efe9] flex items-center justify-center text-[#111827]/50 text-sm" data-testid="emergency-map">
        <MapPin className="w-4 h-4 mr-1.5" /> Location unavailable
      </div>
    );
  }
  const center = [victim.lat, victim.lng];
  const markers = [{ id: "victim", type: "victim", lat: victim.lat, lng: victim.lng, pulse: true, label: "You", sub: label }];
  const routes = [];
  responders.forEach((r) => {
    if (r.lat == null || r.lng == null || r.status === "declined") return;
    const f = r.remainingFrac != null ? r.remainingFrac : (PROGRESS[r.status] ?? 1);
    const lat = victim.lat + (r.lat - victim.lat) * f;
    const lng = victim.lng + (r.lng - victim.lng) * f;
    const sub = r.moving && r.liveRemainingKm != null ? `${r.liveRemainingKm} km away` : `${r.eta_min} min · ${r.distance_km} km`;
    markers.push({ id: r.id, type: "responder", lat, lng, letter: r.name?.[0] || "R", label: r.name, sub });
    if (r.status === "accepted" || r.status === "en_route") routes.push([[lat, lng], center]);
  });
  return (
    <div data-testid="emergency-map">
      <LiveMap center={center} zoom={15} height={220} markers={markers} routes={routes} accuracyM={accuracy} testId="emergency-map-canvas" />
      <div className="flex items-center justify-between mt-2 px-1">
        <span className="text-[11px] font-semibold text-[#111827]/60 flex items-center gap-1"><MapPin className="w-3 h-3" /> {label}</span>
        {accuracy != null && <span className="text-[11px] font-semibold text-[#111827]/50">±{Math.round(accuracy)}m</span>}
      </div>
    </div>
  );
};
